/**
 * Created by saeed on 12/29/2016.
 */
import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {
  API_URL_FINAL_CONFIRM_ORDER_BAG,
  API_URL_GET_ORDER_BAG_DETAIL_BY_ID,
  API_URL_GET_USER_CAN_PAY_INPLACE,
  API_URL_PAY_ORDER_BAG,
  BASE_WEDOMEET_API_URL,
  CREATE_VIDEO_MEETING_API_URL,
  IS_VIDEO_MEETING_RUNNING_API_URL, JOIN_VIDEO_MEETING_API_URL,
  WEDOMEET_SECRET_KEY
} from '../constants';
import {BaseHttpService} from "../base-http-service";
import {MeetingVM} from "../../models/MeetingVM.model";
// import jsSHA from "jssha";
import {MeetingUserVM} from "../../models/MeetingUserVM.model";
import {OrderBagVM} from "../../models/OrderBagVM.model";
import {MeetingResponseVM} from "../../models/MeetingResponseVM.model";

@Injectable()
export class WedomeetService {
  // Resolve HTTP using the constructor
  constructor(private http: HttpClient ) {


  }

  createMeeting(meeting:MeetingVM): any {
    return this.http.post(CREATE_VIDEO_MEETING_API_URL,meeting).toPromise();
    // ...and calling .json() on the response to return data
    //   .map((res: Response) => {
    //     return res;
    //   })
    //   //...errors if any
    //   .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  joinMeeting(meeting:MeetingVM): any {
    return this.http.post(JOIN_VIDEO_MEETING_API_URL,meeting).toPromise();
    // ...and calling .json() on the response to return data
    //   .map((res: Response) => {
    //     return res;
    //   })
    //   //...errors if any
    //   .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  makeCheckSum(method, query,opts?:any):any{;
      // opts = {};
      // opts.shaType === 'sha256';
      //
      // var c, shaObj, str;
      // let salt = WEDOMEET_SECRET_KEY;
      // query || (query = "");
      // str = method + query + salt;
      // if (opts && opts.shaType === 'sha256') {
      //   shaObj = new jsSHA("SHA-256", "TEXT");
      // } else {
      //   shaObj = new jsSHA("SHA-1", "TEXT");
      // }
      // shaObj.update(str);
      // c = shaObj.getHash("HEX");
       return null;
  }

  isMeetingRunning(orderBagItemId:number){
    return this.http.get(IS_VIDEO_MEETING_RUNNING_API_URL+ '/' + orderBagItemId);
  }

  // isMeetingRunning(meetingId:string): boolean
  // {
  //
  //   if(!meetingId)
  //     return false ;
  //
  //   let createLink ='';
  //   let query ='';
  //
  //
  //   if(meetingId){
  //     createLink +='meetingID='+meetingId;
  //     query ='meetingID='+meetingId;
  //   }
  //
  //   createLink += "&checksum="+this.makeCheckSum('isMeetingRunning',query);
  //
  //   createLink =BASE_WEDOMEET_API_URL+'/isMeetingRunning?'+createLink;
  //
  //
  //   this.http.get(createLink)
  //   // ...and calling .json() on the response to return data
  //     .map((res: Response) => {
  //       return res['running'];
  //     })
  //     //...errors if any
  //     .catch((error: any) => Observable.throw(error || 'Server error'));
  //   return false;
  // }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/wedomeet/wedomeet.service.ts